/* Best Mobiles — motion controller.
 * Progressive enhancement: the class that enables the hidden-start state is only
 * added here, so if this file fails to load every element stays visible.
 * Everything is transform/opacity, driven by IntersectionObserver (no scroll handler
 * except the rAF-throttled parallax and header shade). */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window)) return;
  root.classList.add('bm-motion');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // ---- split the hero headline into words (once) ----
    var headline = document.querySelector('[data-bm-split]');
    if (headline && !headline.dataset.bmSplitDone) {
      var text = headline.textContent.trim();
      var words = text.split(/\s+/);
      headline.setAttribute('aria-label', text);
      headline.textContent = '';
      words.forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'bm-word';
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--i', String(i));
        span.textContent = w;
        headline.appendChild(span);
        if (i < words.length - 1) headline.appendChild(document.createTextNode(' '));
      });
      headline.dataset.bmSplitDone = '1';
    }

    // ---- stagger reveal targets inside each group ----
    document.querySelectorAll('[data-bm-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-bm-stagger'), 10) || 60;
      var kids = group.querySelectorAll('[data-bm-reveal]');
      Array.prototype.forEach.call(kids, function (el, i) {
        el.style.setProperty('--bm-delay', Math.min(i * step, 420) + 'ms');
      });
    });

    // ---- reveal on enter ----
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bm-in');
        io.unobserve(entry.target);
        if (entry.target.hasAttribute('data-bm-count')) runCount(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('[data-bm-reveal], .bma .hero, [data-bm-count]').forEach(function (el) {
      io.observe(el);
    });

    // Anything already above the fold at load reveals immediately, so the hero
    // never waits on a scroll that may not come.
    requestAnimationFrame(function () {
      document.querySelectorAll('[data-bm-reveal], .bma .hero').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) { el.classList.add('bm-in'); io.unobserve(el); }
      });
    });

    // ---- number count-up ----
    function runCount(el) {
      var target = parseFloat(el.getAttribute('data-bm-count'));
      if (isNaN(target)) return;
      if (reduced) { el.textContent = String(target); return; }
      var suffix = el.getAttribute('data-bm-suffix') || '';
      var dur = 900, t0 = null;
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    // ---- hero parallax (rAF-throttled, transform only) ----
    var heroBg = document.querySelector('.hero--photo .hero-bg');
    if (heroBg && !reduced) {
      var hero = heroBg.closest('.hero');
      var pTick = false;
      var applyParallax = function () {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        // Drift the background at ~18% of scroll speed. The element is inset
        // -6% top and bottom, so it never exposes an edge.
        var shift = (window.scrollY - hero.offsetTop) * 0.18;
        heroBg.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
      };
      window.addEventListener('scroll', function () {
        if (pTick) return;
        pTick = true;
        requestAnimationFrame(function () { applyParallax(); pTick = false; });
      }, { passive: true });
      applyParallax();
    }

    // ---- ticker: duplicate the content so the loop has no visible seam ----
    var track = document.querySelector('[data-bm-marquee]');
    if (track && !reduced) {
      var inner = track.firstElementChild;
      if (inner) {
        var clone = inner.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        track.classList.add('is-running');
      }
    }

    // ---- header shade after scroll ----
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        document.body.classList.toggle('bma-scrolled', window.scrollY > 8);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();
